import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [
    { id: 1, count: 0, amount: 0, gst: 0, isExpanded: false },
  ],
};

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    addItem(state) {
      const newItem = {
        id: state.items.length + 1,
        count: 0,
        amount: 0,
        gst: 0,
        isExpanded: false,
      };
      state.items.push(newItem);
    },
    updateItem(state, action) {
      const { id, updatedData } = action.payload;
      const item = state.items.find((item) => item.id === id);
      if (item) {
        Object.assign(item, updatedData);
      }
    },
  },
});

export const { addItem, updateItem } = invoiceSlice.actions;

export default invoiceSlice.reducer;
